// Agriculture Unit Tests and Exercises - Years 11-13
// Based on Vanuatu National Syllabus

// Year 11 Agriculture Unit Tests
export const year11AgricultureUnitTests = {
  term1: {
    title: "Term 1 - Sustainable Farm Ecosystem & Soil Management",
    tests: [
      {
        title: "Unit Test 1: Natural and Farm Ecosystems",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Short Answer", marks: 20, questions: 5 },
          { name: "Section C: Extended Response", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Define natural ecosystem and farm ecosystem",
          "Compare and contrast natural and farm ecosystems in terms of sustainability",
          "Explain the role of the farmer in managing a farm ecosystem"
        ]
      },
      {
        title: "Unit Test 2: Agricultural Management Systems",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Definitions and Features", marks: 20, questions: 5 },
          { name: "Section C: Discussion Questions", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Define mono-cropping, multi-cropping, organic farming, and agro-forestry",
          "Describe the ecological benefits of organic farming",
          "Discuss the importance of diversification in agriculture"
        ]
      },
      {
        title: "Unit Test 3: Soil Properties",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Soil Analysis", marks: 20, questions: 5 },
          { name: "Section C: Practical Application", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Describe the physical properties of soil texture and structure",
          "Explain the role of Rhizobia bacteria in nitrogen fixation",
          "Identify deficiency symptoms of nitrogen, phosphorus, and potassium"
        ]
      }
    ]
  },
  term2: {
    title: "Term 2 - Plant and Animal Production",
    tests: [
      {
        title: "Unit Test 4: Crop Establishment",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Process Description", marks: 20, questions: 5 },
          { name: "Section C: Practical Planning", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Identify factors to consider when selecting a planting site",
          "Compare traditional and modern nursery techniques",
          "Describe the steps in establishing a crop from soil preparation to transplanting"
        ]
      },
      {
        title: "Unit Test 5: Crop Growth and Livestock Establishment",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Factors Analysis", marks: 20, questions: 5 },
          { name: "Section C: Feed Calculations", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "List biological, environmental, and husbandry factors affecting plant growth",
          "Explain how pruning is used to manipulate plant growth",
          "Use Pearson's square method to formulate a livestock ration"
        ]
      },
      {
        title: "Unit Test 6: Livestock Management",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Husbandry Tasks", marks: 20, questions: 5 },
          { name: "Section C: Growth Analysis", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Define husbandry tasks: feeding, castration, eye teeth cutting",
          "Explain how breed and health factors affect livestock growth",
          "Analyze growth data to identify feed efficiency"
        ]
      }
    ]
  },
  term3: {
    title: "Term 3 - Crop and Animal Protection & Farm Management",
    tests: [
      {
        title: "Unit Test 7: Pests, Diseases and Weeds",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Identification and Description", marks: 20, questions: 5 },
          { name: "Section C: Life Cycle Analysis", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Distinguish between ecto-parasites and endo-parasites",
          "Name and describe three invasive weeds found in Vanuatu",
          "Draw and label the complete life cycle of an insect pest"
        ]
      },
      {
        title: "Unit Test 8: Pest Management and Economics",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Control Methods", marks: 20, questions: 5 },
          { name: "Section C: IPM Analysis", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Compare biological, chemical, and cultural pest control methods",
          "Describe safe procedures for applying pesticides",
          "Explain the principles of Integrated Pest Management (IPM)"
        ]
      },
      {
        title: "Unit Test 9: Farm Management",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Cost Calculations", marks: 20, questions: 5 },
          { name: "Section C: Market Analysis", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Calculate establishment and production costs for a small project",
          "Define market, demand, supply, and price",
          "Discuss the role of record keeping in good farm management"
        ]
      }
    ]
  },
  practicalAssessments: [
    {
      title: "Practical 1: Soil Testing",
      duration: "60 minutes",
      marks: 30,
      skills: ["Determine soil texture by feel method", "Test soil pH", "Observe soil organisms"]
    },
    {
      title: "Practical 2: Crop Establishment",
      duration: "90 minutes",
      marks: 30,
      skills: ["Prepare a nursery bed", "Sow seeds at correct spacing", "Water and label properly"]
    },
    {
      title: "Practical 3: Feed Formulation",
      duration: "45 minutes",
      marks: 20,
      skills: ["Calculate feed ration using Pearson's square", "Identify feed ingredients", "Mix feed correctly"]
    }
  ]
};

// Year 12 Agriculture Unit Tests
export const year12AgricultureUnitTests = {
  term1: {
    title: "Term 1 - Farm Ecosystems & Soil Improvement",
    tests: [
      {
        title: "Unit Test 1: Integrated Farm Management",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: System Comparison", marks: 20, questions: 5 },
          { name: "Section C: Case Analysis", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Compare extensive, semi-intensive, and intensive farming systems",
          "Explain how integrated farm management contributes to sustainability",
          "Evaluate a local farm enterprise for sustainability practices"
        ]
      },
      {
        title: "Unit Test 2: Traditional and Introduced Farming Systems",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: System Features", marks: 20, questions: 5 },
          { name: "Section C: Comparison Essay", marks: 15, questions: 1 }
        ],
        sampleQuestions: [
          "Define bush fallow, alley cropping, and agro-forestry",
          "Describe ecological benefits of traditional farming systems",
          "Evaluate differences between traditional and introduced farming systems"
        ]
      },
      {
        title: "Unit Test 3: Improving Soil Properties",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Improvement Techniques", marks: 20, questions: 5 },
          { name: "Section C: Practical Application", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Describe ways to improve soil physical properties",
          "Discuss use of organic matter and compost to improve soil",
          "Explain the roles of different soil organisms"
        ]
      }
    ]
  },
  term2: {
    title: "Term 2 - Plant and Animal Production",
    tests: [
      {
        title: "Unit Test 4: Seed Production and Crop Management",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Process Description", marks: 20, questions: 5 },
          { name: "Section C: Timeline Development", marks: 15, questions: 1 }
        ],
        sampleQuestions: [
          "Describe the complete process of seed production",
          "List criteria for selecting plants for seed production",
          "Develop a crop management timeline for a selected crop"
        ]
      },
      {
        title: "Unit Test 5: Livestock Breeding and Management",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Breeding Systems", marks: 20, questions: 5 },
          { name: "Section C: Management Comparison", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Define inbreeding, cross-breeding, and line breeding",
          "Describe advantages and disadvantages of different breeding systems",
          "Compare traditional and modern livestock management systems"
        ]
      },
      {
        title: "Unit Test 6: Value Adding",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Post-harvest Handling", marks: 20, questions: 5 },
          { name: "Section C: Value Adding Analysis", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Describe steps in post-harvest handling to add value",
          "Discuss value adding processes for a selected crop",
          "Explain the importance of post-slaughter handling for meat products"
        ]
      }
    ]
  },
  term3: {
    title: "Term 3 - Protection & Economics",
    tests: [
      {
        title: "Unit Test 7: Pests and Disease Control",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Control Methods", marks: 20, questions: 5 },
          { name: "Section C: IPM Application", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Describe features of common pests and diseases",
          "Explain physiological changes caused by pest damage",
          "Discuss most appropriate control measures for selected pests"
        ]
      },
      {
        title: "Unit Test 8: Economics of Pest Control",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Economic Calculations", marks: 20, questions: 5 },
          { name: "Section C: Recommendations", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Estimate economic loss due to pest damage",
          "Explain the concept of economic threshold",
          "Discuss economic implications of pests on product trade"
        ]
      },
      {
        title: "Unit Test 9: Cash Flow and Gross Margin",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Financial Calculations", marks: 20, questions: 5 },
          { name: "Section C: Budget Preparation", marks: 15, questions: 1 }
        ],
        sampleQuestions: [
          "Calculate gross margin for a given enterprise",
          "Prepare a simple cash flow statement",
          "Explain how market forces affect farm production decisions"
        ]
      }
    ]
  },
  internalAssessment: {
    task1: {
      title: "Research Project",
      weight: 20,
      duration: "4 weeks",
      description: "Investigate a crop or livestock management practice in your local area"
    },
    task2: {
      title: "Practical Investigation",
      weight: 20,
      duration: "3 weeks",
      description: "Conduct an experiment on soil improvement or pest control"
    }
  }
};

// Year 13 Agriculture Unit Tests
export const year13AgricultureUnitTests = {
  term1: {
    title: "Term 1 - Global Issues & Soil Productivity",
    tests: [
      {
        title: "Unit Test 1: Global Environmental Issues",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Issue Analysis", marks: 20, questions: 5 },
          { name: "Section C: Case Study", marks: 15, questions: 1 }
        ],
        sampleQuestions: [
          "Identify global agricultural issues affecting farming in Vanuatu",
          "Explain effects of climate change on selected crops",
          "Discuss advantages and disadvantages of introducing new species"
        ]
      },
      {
        title: "Unit Test 2: Sustainable Farm Management",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Sustainability Techniques", marks: 20, questions: 5 },
          { name: "Section C: Impact Assessment", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Describe features of organic farming practices",
          "Explain how sustainable farms protect biodiversity",
          "Evaluate impacts of farming and climate change on farm land"
        ]
      },
      {
        title: "Unit Test 3: Soil Productivity",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Productivity Assessment", marks: 20, questions: 5 },
          { name: "Section C: Conservation Economics", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "List factors that foster or reduce soil productivity",
          "Propose soil amendments based on soil test results",
          "Evaluate economic benefits of soil conservation"
        ]
      }
    ]
  },
  term2: {
    title: "Term 2 - Breeding & Production Operations",
    tests: [
      {
        title: "Unit Test 4: Crop Breeding",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Breeding Methods", marks: 20, questions: 5 },
          { name: "Section C: Program Design", marks: 15, questions: 1 }
        ],
        sampleQuestions: [
          "Describe main steps in breeding new seeds",
          "Explain selection, hybridization, and line breeding techniques",
          "Design a simple crop breeding program for a selected crop"
        ]
      },
      {
        title: "Unit Test 5: Livestock Breeding",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Breeding Techniques", marks: 20, questions: 5 },
          { name: "Section C: AI Analysis", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Define pure breeding, crossbreeding, inbreeding, and hybridization",
          "Draw schematic diagrams of crossbreeding",
          "Describe advantages and disadvantages of artificial insemination"
        ]
      },
      {
        title: "Unit Test 6: Schedule of Operations",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Activity Planning", marks: 20, questions: 5 },
          { name: "Section C: Schedule Development", marks: 15, questions: 1 }
        ],
        sampleQuestions: [
          "Sketch production processes for selected crops",
          "Categorize activities as managerial, husbandry, or environmental inputs",
          "Design a schedule of operations for a selected enterprise"
        ]
      }
    ]
  },
  term3: {
    title: "Term 3 - Biosecurity & Trade Economics",
    tests: [
      {
        title: "Unit Test 7: Biosecurity Regulations",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Regulation Analysis", marks: 20, questions: 5 },
          { name: "Section C: Impact Evaluation", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Define biosecurity regulations and quarantine laws",
          "List quarantine laws on export and import of agricultural items",
          "Evaluate effects of quarantine laws on regional trade"
        ]
      },
      {
        title: "Unit Test 8: Trade and Marketing",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Marketing Channels", marks: 20, questions: 5 },
          { name: "Section C: Trade Analysis", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Identify marketing pathways from producers to consumers",
          "Explain how WTO affects agricultural trade",
          "Discuss need for farm products to meet international standards"
        ]
      },
      {
        title: "Unit Test 9: Profitability Analysis",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Financial Tools", marks: 20, questions: 5 },
          { name: "Section C: Enterprise Comparison", marks: 15, questions: 1 }
        ],
        sampleQuestions: [
          "Use financial tools to determine profitability",
          "Carry out partial budgeting for two enterprises",
          "Analyse gross margins to find the most profitable enterprise"
        ]
      }
    ]
  },
  internalAssessment: {
    project: {
      title: "Extended Practical Investigation",
      weight: 16,
      duration: "8 weeks",
      description: "Conduct an in-depth investigation on a crop or livestock production system"
    },
    task1: {
      title: "Research Task",
      weight: 14,
      duration: "4 weeks",
      description: "Research a global agricultural issue affecting Vanuatu"
    },
    task2: {
      title: "Shorter Practical Investigation",
      weight: 10,
      duration: "3 weeks",
      description: "Investigate soil productivity or pest management on a local farm"
    }
  },
  externalExamination: {
    duration: "3 hours",
    totalMarks: 100,
    structure: [
      { section: "Section A: Multiple Choice", marks: 25, questions: 25 },
      { section: "Section B: Short Answer", marks: 35, questions: 10 },
      { section: "Section C: Extended Response", marks: 40, questions: 4 }
    ]
  }
};

export default {
  year11: year11AgricultureUnitTests,
  year12: year12AgricultureUnitTests,
  year13: year13AgricultureUnitTests
};
